let loadCount = {};

export function loadingCount(type) {
    loadCount[type] ? loadCount[type]++ : (loadCount[type] = 1);
}

export function loadingDecrease(type) {
    loadCount[type] && loadCount[type]--;

    return !loadCount[type];
}